/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { BrnoDocRetrieveResponse } from '../types/BrnoDocRetrieve';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type BrnoDocsRetrieveRequest = {} | null | undefined;
export type BrnoDocsRetrieveResponse = BrnoDocRetrieveResponse;

export type BrnoDocsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/brno_docs/{id}/
 *
 * ```yaml
 * operationId: brno_docs_retrieve
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BrnoDocRetrieve'
 *     description: ''
 * ```
 */
export const brnoDocsRetrieveOperation = ({ id, ...rest }: BrnoDocsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/brno_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/brno_docs/{id}/' };
  };

/**
 * GET /dmx-server/brno_docs/{id}/
 *
 * ```yaml
 * operationId: brno_docs_retrieve
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BrnoDocRetrieve'
 *     description: ''
 * ```
 */
export const brnoDocsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: BrnoDocsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<BrnoDocRetrieveResponse>> => {
  const operation = brnoDocsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/brno_docs/{id}/
 */
export const useBrnoDocsRetrieveResource = (
  query: BrnoDocsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<BrnoDocsRetrieveResponse> => {
  return useResource<BrnoDocsRetrieveResponse>({
    path: query === null ? null : brnoDocsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
